"use client";

import AccountInfo from "./AccountInfo/page";

export default function PersonalInfoPage() {
  return <AccountInfo />;
}
